import { useRef } from "react";
import ConstantsTexts from "../constants/ConstantsTexts";

export const useCustomValidation = (validationMessage = ConstantsTexts.CODE_162) => {
  const inputRef = useRef(null);

  const handleInvalid = (e) => {
    e.target.setCustomValidity(validationMessage);
  };

  const handleChange = (e) => {
    e.target.setCustomValidity("");
  };

  return {
    ref: inputRef,
    onInvalid: handleInvalid,
    onChange: handleChange,
  };
};
